import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import {
  ItemInfoCard,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingMindsetTemplate/Layout/ItemInfoCard';
import fr from 'facet-rest';
import PlannerAssignmentStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingWhatIsNext/PlannerAssignmentStepHeader';

function OnboardingPostOnboardingWhatIsNext() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  if (!resource) return null;

  const itemInformationRecords = resource.attr('itemInformationRecords').resources().list();

  return (
    <FDStack direction={'column'} spacing={4}>
      <PlannerAssignmentStepHeader resource={resource} />
      <FDStack
        direction={'column'}
        spacing={4}
        justifyContent={'center'}
      >
        {itemInformationRecords.map((itemInfo) => (
          <ItemInfoCard
            key={itemInfo.id()}
            mediaSrc={itemInfo.relationship(fr.relationships.media.name)?.link('related').url()}
            title={itemInfo.attr('title')}
            description={itemInfo.attr('description')}
          />
        ))}
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDStack>
  );
}

export default OnboardingPostOnboardingWhatIsNext;
